import { createFileRoute, stripSearchParams } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'

import { GlobalRoleType } from '@beaded/models'

import { requireGlobalRole } from 'lib/routeGuards'

import BomConfiguration from 'pages/BomConfiguration'

const bomSearchSchema = z.object({
  tab: z
    .enum(['parts', 'routings', 'mappings', 'transitions'])
    .optional()
    .default('parts'),
})

const bomSearchDefaults = { tab: 'parts' } as const

export const Route = createFileRoute('/_auth/_global/bom-configuration')({
  beforeLoad: requireGlobalRole(
    GlobalRoleType.CABLE_ADMIN,
    GlobalRoleType.GLOBAL_ADMIN,
  ),
  component: BomConfiguration,
  validateSearch: zodValidator(bomSearchSchema),
  search: {
    middlewares: [stripSearchParams(bomSearchDefaults)],
  },
})
